import { MapContainer } from "react-leaflet";
import styled from "styled-components";

export const Wrapper = styled.div`
  height: 800px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 1fr 3fr;
`;

export const Map = styled(MapContainer)`
  width: 100%;
  position: relative;
  border-radius: 4px;
`;
